export * from "./NewsDetails.async";
